import classNames from 'classnames';
import { StylishNewToggleButtonGroup } from 'components/DesignSystems/New/StylishNewToggleButtonGroup';
import { useUpsertIncidentStatusSummary } from 'components/IAP/hooks/incidentStatusSummaryHooks';
import { STATUS_SUMMARY_REPORT_VERSIONS } from 'components/IAP/ICSConstants';
import React from 'react';

type ReportVersionToggleProps = {
  statusSummaryId?: string;
  originalReportVersion?: string;
  readOnly?: boolean;
};

const ReportVersionToggle: React.FC<ReportVersionToggleProps> = ({
  statusSummaryId,
  originalReportVersion,
  readOnly = false,
}) => {
  const [reportVersion, setReportVersion] = React.useState<string>(
    originalReportVersion || 'Initial'
  );

  const upsertIncidentStatusSummary =
    useUpsertIncidentStatusSummary(statusSummaryId);

  const handleChange = (value: string) => {
    setReportVersion(value);
    upsertIncidentStatusSummary({ reportVersion: value });
  };

  return (
    <div className={classNames('mt-2', 'col-6')}>
      <label className="form-label">Report Version</label>
      <StylishNewToggleButtonGroup
        data={STATUS_SUMMARY_REPORT_VERSIONS}
        selected={reportVersion}
        onChange={handleChange}
        disabled={readOnly}
      />
    </div>
  );
};

export default ReportVersionToggle;
